import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CAMPRegistration = () => {
  const navigate = useNavigate(); 

  const [formData, setFormData] = useState({
    organizationName: '',
    organizerContactNo: ''
  });


  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

// ...existing code...

  const handleSubmit = async(e) => {
     // Phone number validation (Indian mobile format)
  const phoneRegex = /^[6-9]\d{9}$/;
  if (!phoneRegex.test(formData.organizerContactNo)) {
    alert("Please enter a valid 10-digit Organizer Contact No (starts with 6-9).");
    return;
  }
    e.preventDefault();
    const apiEndpoint =
       //"http://localhost:5121/api/CampRegistration/CampOrganizerRegistration"; // Update with actual API URL
       "https://apiv2.chakran.in/api/CampRegistration/CampOrganizerRegistration";

     const payload = {      
       CampOrganizerName: formData.organizationName,
       OrganizerContactNo: formData.organizerContactNo,
     };

     const authToken = localStorage.getItem("authToken");

    try {
      const response = await fetch(apiEndpoint, {
         method: "POST",
         headers: {
           "Content-Type": "application/json",
           Authorization: `Bearer ${authToken}`,
         },
         body: JSON.stringify(payload),
       });

       if (response.ok) {
         const result = await response.json();   
         
          // ✅ Save response data in localStorage
          localStorage.setItem("organizationName", formData.organizationName);
          localStorage.setItem("organizerContactNo", formData.organizerContactNo);
          localStorage.setItem("campRegistrationId", result.campRegistrationId);
          localStorage.setItem("campRegistrationNo", result.registrationNo);

         console.log("Registration successful:", result);

         // ✅ Redirect to add applicants page
          navigate("/dashboard/add-applicants");

       } else {
      console.error("Failed to register:", response.status, response.statusText);
    }

    // ✅ Reset form
    setFormData({
      organizationName: "",
      organizerContactNo: "",
    });

  } catch (error) {
    console.error("Error during registration:", error);
  }
};

  return (
    <>
        <form onSubmit={handleSubmit}>
          <div className="card card-default">
            <div className="card-body">
              <div className="row">
                <div className="form-group col-md-3">
                  <label htmlFor="registrationNo">CAMP Organizer Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="organizationName"
                    value={formData.organizationName}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group col-md-3">
                  <label htmlFor="organizationName">Organizer Contact No</label>
                  <input
                    type="text"
                    className="form-control"
                    name="organizerContactNo"
                    data-mask="(999) 999-9999" 
                    value={formData.organizerContactNo}
                    onChange={handleChange}
                  />
                  <p style={{fontSize: '90%'}}>ex. (999) 999-9999 <span style={{ color: "red" }}>*</span></p>
                </div>                
              </div>

              <div className="form-footer pt-2">
                <button type="submit" className="btn btn-primary btn-pill">
                  Submit and Add Applicant
                </button>
              </div>
            </div>
          </div>
        </form>
    </>
  );
};

export default CAMPRegistration;

// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';

// const CAMPRegistration = () => {
//   const navigate = useNavigate(); 

//   const [formData, setFormData] = useState({
//     registrationNo: '',
//     organizationName: ''
//   });

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log(formData); // Optional: Check submitted data
//     navigate('/dashboard/add-applicants'); // 🔁 Redirect
//   };

//   return (
//     <div className="row">
//       <div className="col-xl-12">
//         <form onSubmit={handleSubmit}>
//           <div className="card card-default">
//             <div className="card-body">
//               <div className="row">
//                 <div className="form-group col-md-4">
//                   <label htmlFor="registrationNo">Registration No</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="registrationNo"
//                     value={formData.registrationNo}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div className="form-group col-md-4">
//                   <label htmlFor="organizationName">CAMP Organizer Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="organizationName"
//                     value={formData.organizationName}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>

//               <div className="form-footer pt-2 text-center">
              
//                 <button type="submit" className="btn btn-primary btn-pill">
//                   Submit and Add Applicant
//                 </button>
//               </div>
//             </div>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default CAMPRegistration;

// import React, { useState } from "react";
// import { jsPDF } from "jspdf";
// import "jspdf-autotable";

// const CAMPRegistration = () => {
//   const [formItems, setFormItems] = useState([
//     { applicantName: "", services: [] },
//   ]);

//   const [formData, setFormData] = useState({
//     organizationName: "",
//     organizerContactNo: "",
//     dob: "",
//     contactNo: "",
//   });

//   const [registrationNo, setRegistrationNo] = useState(""); // Store registration no from backend

//   const servicesOptions = [
//     "PAN",
//     "ELECTION CARD",
//     "PM Kisan KYC",
//     "E Sharam Card",
//     "PM Ayushman Bharat Card",
//     "Others"
//   ];

//   const handleApplicantChange = (index, field, value) => {
//     const updatedFormItems = formItems.map((item, i) =>
//       i === index ? { ...item, [field]: value } : item
//     );
//     setFormItems(updatedFormItems);
//   };

//   const handleServiceChange = (index, service, checked) => {
//     const updatedFormItems = formItems.map((item, i) => {
//       if (i === index) {
//         const updatedServices = checked
//           ? [...item.services, service]
//           : item.services.filter((s) => s !== service);
//         return { ...item, services: updatedServices };
//       }
//       return item;
//     });
//     setFormItems(updatedFormItems);
//   };

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleAddClick = () => {
//     setFormItems([...formItems, { applicantName: "", services: [] }]);
//   };

//   const formatDateToString = (dob) => {
//     if (!dob) return "";
//     const options = { day: "2-digit", month: "2-digit", year: "numeric" };
//     return new Intl.DateTimeFormat("en-GB", options).format(new Date(dob)); // Format: dd/MM/yyyy
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const apiEndpoint =
//       "http://localhost:5121/api/CampRegistration/CampRegistration"; // Update with actual API URL
//       //"https://apiv2.chakran.in/api/CampRegistration/CampRegistration";

//     const payload = {
//       DateOfBirth: formatDateToString(formData.dob),
//       ContactNo: formData.contactNo,
//       CampOrganizerName: formData.organizationName,
//       OrganizerContactNo: formData.organizerContactNo,
//       Applicants: formItems.map((item) => ({
//         ApplicantName: item.applicantName,
//         Services: item.services,
//       })),
//     };

//     const authToken = localStorage.getItem("authToken");

//     try {
//       const response = await fetch(apiEndpoint, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${authToken}`,
//         },
//         body: JSON.stringify(payload),
//       });

//       if (response.ok) {
//         const result = await response.json();
//         setRegistrationNo(result.registrationNo); // Save registration no from response
//         console.log("Registration successful:", result);
//         generatePDF(result.registrationNo); // Generate PDF with Registration No
//       } else {
//         console.error(
//           "Failed to register:",
//           response.status,
//           response.statusText
//         );
//       }

//       // Clear the form after submission
//       setFormData({
//         organizationName: "",
//         organizerContactNo: "",
//         dob: "",
//         contactNo: "",
//       });
//       setFormItems([{ applicantName: "", services: [] }]);
//     } catch (error) {
//       console.error("Error during registration:", error);
//     }
//   };

//   const generatePDF = (registrationNo) => {
//     const doc = new jsPDF();
  
//     // Draw a border for the entire PDF
//     doc.setLineWidth(0.5);
//     doc.rect(5, 5, 200, 287);
  
//     // Main Heading - Bold
//     doc.setFontSize(16);
//     doc.setFont('helvetica', 'bold');
//     doc.text('CHAKRAN MULTI SERVICES PVT LTD', 105, 15, { align: 'center' });
  
//     // Sub-heading - Bold
//     doc.setFontSize(10);
//     doc.text('Camp Registration Receipt', 105, 25, { align: 'center' });
  
//     // Draw lines under the headings (top and bottom border)
//     doc.setLineWidth(0.5);
//     doc.line(10, 20, 200, 20); // Top border under heading
//     doc.line(10, 30, 200, 30); // Bottom border under sub-heading
  
//     // Content - Normal font
//     doc.setFont('helvetica', 'normal');
//     doc.setFontSize(10);
  
//     // Registration and Organization Details
//     doc.text(`Registration No.: ${registrationNo || 'N/A'}`, 10, 40);
//     doc.text(`Date: ${new Date().toLocaleDateString()}`, 150, 40);
  
//     doc.text('Organization Name:', 10, 50);
//     doc.text(formData.organizationName || 'N/A', 60, 50);
  
//     doc.text('Organizer Contact No:', 10, 60);
//     doc.text(formData.organizerContactNo || 'N/A', 60, 60);

//     doc.text('Contact No.:', 10, 70);
//     doc.text(formData.contactNo || 'N/A', 60, 70);

//     doc.text('Date of Birth:', 10, 80);
//     doc.text(formatDateToString(formData.dob) || 'N/A', 60, 80);
  
//     // Applicant Details (Dynamic)
//     let yOffset = 90;
//     formItems.forEach((item, index) => {
//       doc.text(`Applicant ${index + 1} Name:`, 10, yOffset);
//       doc.text(item.applicantName || 'N/A', 60, yOffset);
  
//       doc.text('Services:', 80, yOffset); // Header for services
//       item.services.forEach((service, serviceIndex) => {
//         doc.text(service, 120, yOffset + 10 + serviceIndex * 10); // Position each service 10px below the previous
//       });
  
//       yOffset += 20 + item.services.length * 10; // Adjust spacing for the next applicant
//     });
  
//     // Office Address
//     doc.text('Office Address:', 10, yOffset);
//     doc.text(
//       'Shop No.5, Shanti Nagar Dongari, Near Canara Bank,\nS V Road, Dahisar East, Mumbai - 400068',
//       10,
//       yOffset + 5
//     );
  
//     // Contact Details
//     yOffset += 30; // Move below the address
//     doc.text('Mobile No.: 9967318555', 10, yOffset);
//     doc.text('Email Id: xyz@chakran.in', 10, yOffset + 10);
  
//     // Footer
//     yOffset += 40; // Adjust for footer
//     doc.setFont('helvetica', 'normal');
//     doc.text('For, CHAKRAN MULTI SERVICES PVT LTD', 110, yOffset); 
//     doc.text('Authorized Signatory', 130, yOffset + 20);
  
//     doc.save('Camp_Receipt.pdf');
//   };
  

//   return (
//     <>
//       <div className="row">
//         <div className="col-xl-12">
//           {/* Ensure onSubmit is inside form */}
//           <form onSubmit={handleSubmit}>
//             <div className="card card-default">
//               <div className="card-body">
//                 <div className="row">
//                   {/* <div className="form-group col-md-4">
//                     <label htmlFor="AreaCode">Registration No</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="registrationNo"
//                       onChange={handleChange}
//                     />
//                   </div> */}
//                   <div className="form-group col-md-4">
//                     <label htmlFor="AreaCode">CAMP Organizer Name</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="organizationName"
//                       value={formData.organizationName}
//                       onChange={handleChange}
//                     />
//                   </div>
//                   <div className="form-group col-md-4">
//                     <label htmlFor="AoType">Organizer Contact No.</label>
//                     <input type="text" 
//                       className="form-control" 
//                       name="organizerContactNo"
//                       value={formData.organizerContactNo}
//                       onChange={handleChange}/>
//                   </div>
//                   <div className="form-group col-md-4">
//                     <label htmlFor="AONo">Date Of Birth</label>
//                     <input
//                       type="date"
//                       className="form-control"
//                       data-mask="00/00/0000"
//                       name="dob"
//                       value={formData.dob}
//                       onChange={handleChange}
//                     />
//                     <p style={{ fontSize: '90%' }}>ex. 99/99/9999</p>
//                   </div>
//                   <div className="form-group col-md-4">
//                     <label htmlFor="AONo">Contact No</label>
//                     <div className="input-group mb-3">
//                       <div className="input-group-prepend">
//                         <span className="input-group-text mdi mdi-phone"></span>
//                       </div>
//                       <input
//                         type="text"
//                         className="form-control"
//                         data-mask="(999) 999-9999"
//                         placeholder="Mobile No"
//                         name="contactNo"
//                         value={formData.contactNo}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 {/* Render the dynamic input fields */}
//                 {formItems.map((item, index) => (
//                   <div key={index} className="row">
//                     <div className="form-group col-md-4">
//                       <label htmlFor="AONo">Applicant Name</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         name="applicantName"
//                         value={item.applicantName}
//                         onChange={(e) =>
//                           handleApplicantChange(index, "applicantName", e.target.value)
//                         }
//                       />
//                     </div>

//                     <div className="form-group col-md-8">
//                       <label htmlFor="AONo">Service</label><br />
//                       {servicesOptions.map((service, idx) => (
//                         <div key={idx} className="checkboxleft">
//                           <input
//                             type="checkbox"
//                             name="services"
//                             value={service}
//                             checked={item.services.includes(service)}
//                             onChange={(e) =>
//                               handleServiceChange(
//                                 index,
//                                 service,
//                                 e.target.checked
//                               )
//                             }
//                           />
//                           <label>{service}</label>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 ))}
//                 <button
//                   type="button"
//                   className="btn btn-primary btn-pill"
//                   onClick={handleAddClick}
//                 >
//                   + Add Applicant
//                 </button>
//                 <div className="form-footer pt-2">
//                   <button type="submit" className="btn btn-primary btn-pill">
//                     Submit
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// };

// export default CAMPRegistration;



